import type { RuleGroupType } from 'react-querybuilder';
import type { HardwaresDataItem } from '../../queries/getHardwareData';

type EnumKeys<T> = {
  [K in keyof T]: T[K] extends string ? K : never;
}[keyof T];

type EnumLike<T> = {
  [K in EnumKeys<T>]: T[K];
};

export const enumToOptions = <T extends EnumLike<T>>(enumType: T): { name: string; label: string }[] =>
  Object.values(enumType)
    .sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()))
    .map((value: string) => ({ name: value, label: value }));

const defaultQuery = {
  combinator: 'and',
  rules: [],
};

export const parseQuery = (hardware?: HardwaresDataItem): RuleGroupType => {
  return { ...defaultQuery, ...hardware?.query };
};
